function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "arrow_down",
  transform: "translate(-133 -486)",
  fill: "none",
  stroke: "#1ec19d",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  id: "Line_1",
  "data-name": "Line 1",
  transform: "translate(148 486)",
  d: "M0 0v30"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M194.795 426.191l6 6 6-6",
  transform: "translate(-52.795 83.809)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Union_3",
  "data-name": "Union 3",
  d: "M28 6H0V0h2v4h26V0h2v6z",
  transform: "translate(0 34)",
  fill: "#0b6670"
});

var SvgIcDownload = function SvgIcDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_download",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_download.b94fc854.svg";
export { ForwardRef as ReactComponent };